import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Filler,
  Legend,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Filler, Legend);

const CpanelActivityChart = ({ labels = [], counts = [], total = 0, loading = false }) => {
  const chartData = useMemo(
    () => ({
      labels,
      datasets: [
        {
          label: 'Aktivitas',
          data: counts,
          borderColor: '#009ef7',
          backgroundColor: 'rgba(0, 158, 247, 0.12)',
          borderWidth: 2,
          pointRadius: 4,
          pointHoverRadius: 6,
          pointBackgroundColor: '#009ef7',
          tension: 0.35,
          fill: true,
        },
      ],
    }),
    [labels, counts]
  );

  const options = useMemo(
    () => ({
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { display: false },
        tooltip: {
          callbacks: {
            label: (ctx) => `${ctx.parsed.y} aktivitas`,
          },
        },
      },
      scales: {
        x: {
          grid: { display: false },
          ticks: { color: '#a1a5b7', font: { size: 11 } },
        },
        y: {
          beginAtZero: true,
          ticks: {
            stepSize: 1,
            precision: 0,
            color: '#a1a5b7',
            font: { size: 11 },
          },
          grid: { color: 'rgba(0, 0, 0, 0.04)' },
        },
      },
    }),
    []
  );

  return (
    <div className="card cpanel-card cpanel-activity-chart h-100">
      <div className="card-header border-0 pt-6 align-items-center">
        <div>
          <h3 className="card-title fw-bold text-gray-800 mb-1">Aktivitas sistem</h3>
          <div className="text-muted fs-8">
            {loading ? 'Memuat data…' : `${total} total aktivitas · 7 hari terakhir`}
          </div>
        </div>
        <div className="card-toolbar">
          <Link to="/cpanel/logs" className="btn btn-sm btn-light-primary">
            Lihat
          </Link>
        </div>
      </div>
      <div className="card-body pt-2 pb-6">
        <div className="cpanel-activity-chart__canvas-wrap">
          {loading ? (
            <div className="cpanel-dashboard-empty">Memuat chart…</div>
          ) : (
            <Line data={chartData} options={options} />
          )}
        </div>
      </div>
    </div>
  );
};

export default CpanelActivityChart;
